import { BLOCKS, INLINES } from '@contentful/rich-text-types';
export var richTextDisclaimer = function richTextDisclaimer(buttonText) {
  return {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "By clicking \"".concat(buttonText, "\" you agree to our "),
        nodeType: "text"
      }, {
        data: {
          uri: "https://www.twilio.com/legal/tos"
        },
        content: [{
          data: {},
          marks: [],
          value: "Terms of Service",
          nodeType: "text"
        }],
        nodeType: INLINES.HYPERLINK
      }, {
        data: {},
        marks: [],
        value: " and ",
        nodeType: "text"
      }, {
        data: {
          uri: "https://www.twilio.com/legal/privacy/"
        },
        content: [{
          data: {},
          marks: [],
          value: "Privacy Notice",
          nodeType: "text"
        }],
        nodeType: INLINES.HYPERLINK
      }, {
        data: {},
        marks: [],
        value: ".",
        nodeType: "text"
      }],
      nodeType: BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: BLOCKS.DOCUMENT
  };
};